import React, { Component } from 'react';
import Dashboard  from '../../components/dashboard';
import {fetchDashboardData} from '../../actions/dashboard';
import {connect} from 'react-redux';

class Dashboards extends Component {
  constructor(props){
    super(props)
    this.state = {
    }
 
  }

    componentWillMount() {
      let token=sessionStorage.getItem("adminToken");
      this.props.dispatch(fetchDashboardData(token));
    }


  render() {
    if(!this.props.authenticated){
     
         let adminToken=sessionStorage.getItem("adminToken");
          if(adminToken){
        //   this.props.dispatch(fetchStudy(userId, access_token));
         }else {
           alert("Please login.");
           this.props.history.push("login");
         }
  }

   let dashboardList ="";

        dashboardList = <Dashboard
            success = {this.props.success}
            dashboardData = {this.props.dashboardData}
            />

   return (
      <div>
        {dashboardList}
      </div>
   );
  }
}

const  mapStateToProps =(state) =>{
  return {
    authenticated : state.login.authenticated,
    success: state.dashboard.success,
    dashboardData: state.dashboard.dashboardData
  }
}

export default connect(mapStateToProps)(Dashboards);



// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js